module.exports = __webpack_public_path__ + "static/media/SmartShop_2-424w.548d6ab3.png";